import React from 'react';

export const pageMeta = {
  "name": "DOM Intro",
  "link": "/javascript/dom/intro"
};

export default function JavascriptDomIntro() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">DOM Intro</h2>
      <p>Route: /javascript/dom/intro</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
